import { Button, Checkbox, Form, InputNumber, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import type { TableProps } from "antd/es/table";
import { useEffect, useState } from "react";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import { useGetDepartmentsQuery } from "../../../features/department/departmentApi";
import { useGetEmployeesQuery } from "../../../features/employee/employeeApi";
import { useAddLeaveProrateManuallyMutation } from "../../../features/leaveProrate/leaveProrateApi";
import { useGetLeaveTypeListQuery } from "../../../features/leaveType/leaveTypeApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { toast } from "../../../lib/toast";
import { EmployeeData, ModalComponentProps } from "../../../types";
import {
  addKeyInArray,
  selectArrayOption,
  selectSearchOption,
} from "../../../utils/utils";
import ConfirmModal from "../../ui/ConfirmModal";
import CustomModal from "../../ui/CustomModal";
import CustomTable from "../../ui/CustomTable";

export default function AddNewManualProrateModal({
  handleClose,
  type,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();
  const [selectedDepartments, setSelectedDepartments] = useState<string[]>([]);
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const {
    open,
    handleOpen,
    handleClose: handleLeaveModalClose,
  } = useModal<undefined, "CONFIRM">();
  const {
    data: departmentsData,
    isError: isDepartmentError,
    error: departmentError,
  } = useGetDepartmentsQuery({
    params: { skip: 0, limit: 0, is_published: 1 },
  });
  const {
    data: leaveTypeListData,
    isError: isLeaveTypeError,
    error: leaveTypeError,
  } = useGetLeaveTypeListQuery({
    params: {
      is_published: 1,
    },
  });
  const {
    isLoading: isEmployeeLoading,
    isError: isEmployeeError,
    error: employeeError,
    data: employeeData,
  } = useGetEmployeesQuery({
    params: {
      skip: 0,
      limit: 0,
      business_department_ids: selectedDepartments,
      status: "active",
    },
  });
  const [addLeaveProrateManually, { isLoading, isError, error, isSuccess }] =
    useAddLeaveProrateManuallyMutation();
  // const [
  //   addLeaveAutoProrateRun,
  //   {
  //     isLoading: leaveAutoProrateRunLoading,
  //     isError: isAutoProrateError,
  //     error: autoProrateError,
  //     isSuccess: isAutoProrateSuccess,
  //   },
  // ] = useAddLeaveAutoProrateRunMutation();

  useError(isDepartmentError, departmentError, "Get department data fail");
  useError(isLeaveTypeError, leaveTypeError, "Get leave type data fail");
  useError(isEmployeeError, employeeError, "Get employee data fail");
  useError(isError, error, "Leave prorate manually create fail");
  // useError(isAutoProrateError, autoProrateError, "Prorate list fetched fail");
  const [newValues, setNewValues] = useState();

  const handleSelectAll = () => {
    const allIds = departmentsData?.data?.departments?.map((el) =>
      String(el.id)
    );
    setSelectedDepartments(allIds || []);
  };

  const handleUnselectAll = () => {
    setSelectedDepartments([]);
  };

  const onFinish = (values: any) => {
    if (!selectedData?.length) {
      toast("error", "Please select minimum one employee");
      return;
    }

    setNewValues({
      ...values,
      total_days: String(values?.total_days),
      business_member_ids: selectedData,
    });
    handleOpen({
      type: "CONFIRM",
    });
  };

  const columns: TableProps<EmployeeData>["columns"] = [
    {
      title: "Employee Id",
      dataIndex: "employee_id",
      render: (val) => val ?? "n/a",
    },
    {
      title: "Employee Name",
      dataIndex: "member",
      render: (val) => val?.profile?.name ?? "n/a",
    },
    // {
    //   title: "ID",
    //   dataIndex: "id",
    // },
  ];

  const handleCheckboxChange = (id: string | number, checked: boolean) => {
    setSelectedDepartments((prev) =>
      checked
        ? [...prev, String(id)]
        : prev.filter((selectedId) => selectedId !== String(id))
    );
  };

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Leave prorate manually created successfully");
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  // success toast message
  // useEffect(() => {
  //   if (isUpdateSuccess) {
  //     toast("success", "Leave prorate manually update successfully");
  //     addLeaveAutoProrateRun({
  //       is_prorated: "yes",
  //       prorate_type: "leave_type_update",
  //     });
  //   }
  // }, [addLeaveAutoProrateRun, isUpdateSuccess]);

  // success toast message
  // useEffect(() => {
  //   if (isAutoProrateSuccess) {
  //     toast("success", "Prorate list fetched successfully");
  //   }
  // }, [handleClose, handleLeaveModalClose, isAutoProrateSuccess]);

  // useEffect(() => {
  //   if (isAutoProrateError || isAutoProrateSuccess) {
  //     handleLeaveModalClose();
  //     handleClose();
  //   }
  // }, [
  //   handleClose,
  //   handleLeaveModalClose,
  //   isAutoProrateError,
  //   isAutoProrateSuccess,
  // ]);

  return (
    <CustomModal
      title={"Add New Manual Prorate"}
      {...rest}
      handleClose={handleClose}
      width={800}
      footer={null}
    >
      {/* {!isAutoProrateError &&
        !isAutoProrateSuccess &&
        leaveAutoProrateRunLoading && <FullScreenLoading />} */}

      {open?.type === "CONFIRM" ? (
        <ConfirmModal
          open={open?.open}
          handleClose={() => {
            handleLeaveModalClose();
            handleClose();
          }}
          handleOk={() => {
            addLeaveProrateManually(newValues);
            // addLeaveAutoProrateRun({
            //   is_prorated: "yes",
            //   prorate_type:
            //     type === "UPDATE" ? "leave_type_update" : "leave_type_create",
            // });
          }}
          confirmTitle="Run Manual Prorate"
          questionText="Are you sure to set manual prorate for these employee?"
          okText="Confirm"
          okLoading={isLoading}
        />
      ) : null}
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="mb-4">
          <div className="px-3 py-2 bg-gray-light rounded-md flex justify-between items-center">
            <div className="flex items-center gap-4">
              <h4 className="text-display-body text-lg font-semibold leading-[30px]">
                Department
              </h4>

              <Checkbox
                className="text-accent text-sm font-medium "
                onClick={handleSelectAll}
                checked={
                  selectedDepartments.length ===
                  departmentsData?.data.departments.length
                }
              >
                Select All
              </Checkbox>
            </div>
            <div>
              <button
                className="text-primary text-sm font-medium"
                onClick={handleUnselectAll}
              >
                Unselect
              </button>
            </div>
          </div>
          <div className="grid md:grid-cols-5 grid-cols-3 gap-2 mt-4">
            {departmentsData?.data.departments.map((el) => (
              <label
                className="flex !items-start gap-2"
                htmlFor={el.id.toString()}
                key={el.id}
              >
                <Checkbox
                  value={el.id}
                  onChange={(e) =>
                    handleCheckboxChange(el.id, e.target.checked)
                  }
                  id={el.id.toString()}
                  checked={selectedDepartments.includes(el.id.toString())}
                />
                {el.name}
              </label>
            ))}
          </div>
        </div>

        {/* Employee Section */}
        <div className="mb-4">
          <div className="px-3 py-2 bg-gray-light rounded-md flex justify-between items-center p-2 mb-2">
            <h4 className="text-display-body text-lg font-semibold leading-[30px]">
              Employee
            </h4>
            {/* <div>
            <Button
              className="flex items-center gap-2 font-semibold !text-primary hover:text-primary"
              type="link"
              icon={<AddIcon />}
            >
              Add Employee
            </Button>
          </div> */}
          </div>

          <div className="max-h-80 overflow-y-auto">
            <CustomTable
              loading={isEmployeeLoading}
              columns={columns}
              dataSource={addKeyInArray(employeeData?.data?.employees)}
              rowSelection={{
                type: "checkbox",
                onChange: (key) => setSelectedData(key as string[]),
                columnWidth: 40,
              }}
              rootClassName="mt-4 !border-x-0"
            />
          </div>
        </div>

        {/* Leave Options Section */}
        <div>
          <div className="px-3 py-2 bg-gray-light rounded-md flex justify-between items-center p-2 mb-4">
            <h4 className="text-display-body text-lg font-semibold leading-[30px]">
              Leave Options
            </h4>
          </div>

          <div className="grid md:grid-cols-2 gap-x-4">
            <Form.Item
              name="leave_type_id"
              label="Leave Type"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please select a leave type",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                options={
                  selectArrayOption(
                    leaveTypeListData?.data?.leave_types,
                    "title",
                    "id"
                  ) || []
                }
                suffixIcon={<SelectDropdownLgIcon />}
              />
            </Form.Item>

            <Form.Item
              name="total_days"
              label="Leave Count"
              className="mb-4"
              validateFirst
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value === 0) {
                      return Promise.reject(
                        new Error("Leave count must be at least 1")
                      );
                    }
                    if (!value) {
                      return Promise.reject(
                        new Error("Please select a leave count")
                      );
                    }
                    if (value === undefined || value < 0) {
                      return Promise.reject(
                        new Error("Leave balance cannot be negative")
                      );
                    }
                    if (!Number.isInteger(value)) {
                      return Promise.reject(
                        new Error("Leave count must be a whole number")
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <InputNumber placeholder="00" className="w-full" />
            </Form.Item>

            <div className="md:col-span-2">
              <Form.Item
                name="note"
                label="Notes"
                className="mb-0"
                rules={[
                  {
                    required: true,
                    message: "Please enter a note",
                  },
                ]}
              >
                <TextArea className="w-full" placeholder="Type note..." />
              </Form.Item>
            </div>
          </div>
        </div>
        <Space className="w-full pt-6 sticky bottom-0 bg-white" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Save
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
